/**
 * 前端可写 Cookie 兜底（非 HttpOnly）。
 * 仅作 localStorage 失败时的二次落盘；不替代现有 LS / memory 主路径。
 * 中长期仍应迁到后端 Set-Cookie HttpOnly。
 */

const MAX_COOKIE_CHARS = 3500;

function isSecureContext() {
  if (typeof window === 'undefined' || typeof location === 'undefined') return false;
  return location.protocol === 'https:' || location.hostname === 'localhost';
}

/**
 * @param {string} name
 * @returns {string|null}
 */
export function readAuthCookie(name) {
  if (typeof document === 'undefined' || !document.cookie) return null;
  try {
    const prefix = `${encodeURIComponent(name)}=`;
    const parts = document.cookie.split(';');
    for (const part of parts) {
      const raw = part.trim();
      if (!raw.startsWith(prefix)) continue;
      const value = raw.slice(prefix.length);
      try {
        return decodeURIComponent(value);
      } catch {
        return value;
      }
    }
  } catch {
    /* cookie 不可读 */
  }
  return null;
}

/**
 * @param {string} name
 * @param {string|null|undefined} value  空则删除
 * @param {{ maxAgeSec?: number }} [options]
 * @returns {boolean}
 */
export function writeAuthCookie(name, value, options = {}) {
  if (typeof document === 'undefined') return false;
  try {
    const key = encodeURIComponent(name);
    if (value == null || value === '') {
      document.cookie = `${key}=; Path=/; Max-Age=0; SameSite=Lax${isSecureContext() ? '; Secure' : ''}`;
      return true;
    }
    const encoded = encodeURIComponent(String(value));
    if (encoded.length > MAX_COOKIE_CHARS) {
      return false;
    }
    const maxAge =
      options.maxAgeSec != null && Number.isFinite(options.maxAgeSec) && options.maxAgeSec > 0
        ? Math.floor(options.maxAgeSec)
        : 60 * 60 * 24 * 7;
    const secure = isSecureContext() ? '; Secure' : '';
    document.cookie = `${key}=${encoded}; Path=/; Max-Age=${maxAge}; SameSite=Lax${secure}`;
    return readAuthCookie(name) === String(value);
  } catch {
    return false;
  }
}

/**
 * @param {string} name
 * @returns {boolean}
 */
export function removeAuthCookie(name) {
  return writeAuthCookie(name, null);
}
